module.exports = __webpack_public_path__ + "img/liucheng5.13c457db.jpg";